const isMatch = (searchStrings, x) => {
  return searchStrings.includes(x.assetId) || searchStrings.some(y => x.address.toUpperCase().replace(/,/g, ' ').replace(/\t/g, ' ').replace(/\p{Space}/g,' ').replace(/  +/g, ' ').includes(y))
}

export {isMatch}
